import { createFileRoute, redirect } from "@tanstack/react-router";

import { ARTICLES } from "@/features/kennisbank/content/registry";

export const Route = createFileRoute("/_authenticated/kennisbank/")({
	beforeLoad: () => {
		throw redirect({
			to: "/kennisbank/$slug",
			params: { slug: ARTICLES[0].slug },
		});
	},
});
